{
  "dashboard.greeting.morning": "Good morning, {name}",
  "dashboard.greeting.afternoon": "Good afternoon, {name}",
  "dashboard.greeting.evening": "Good evening, {name}",
  "dashboard.subtitle": "Here is what needs your attention in customer service today.",
  "dashboard.period.today": "Today",
  "dashboard.period.thisWeek": "This week",
  "dashboard.period.thisMonth": "This month",
  "dashboard.viewReports": "View reports",
  "dashboard.queue.title": "Queue health",
  "dashboard.status.title": "Open backlog by status",
  "dashboard.status.empty": "No open tickets",
  "dashboard.waiting.title": "Longest waiting tickets",
  "dashboard.waiting.description": "Unanswered tickets count from creation; answered ones count from the last update.",
  "dashboard.waiting.search": "Search subject or number…",
  "dashboard.waiting.filter": "Filter tickets",
  "dashboard.waiting.unansweredOnly": "Unanswered only",
  "dashboard.waiting.empty": "No matching tickets",
  "dashboard.waiting.number": "Number",
  "dashboard.waiting.subject": "Subject",
  "dashboard.waiting.project": "Project",
  "dashboard.waiting.team": "Team",
  "dashboard.waiting.assignee": "Assignee",
  "dashboard.waiting.status": "Status",
  "dashboard.waiting.waiting": "Waiting",
  "dashboard.waiting.awaitingFirstResponse": "Unanswered",
  "dashboard.trend.title": "Last 14 days",
  "dashboard.mine.title": "My work",
  "dashboard.mine.activeAssigned": "Assigned to me",
  "dashboard.mine.awaitingMyResponse": "Awaiting my reply",
  "dashboard.mine.resolvedToday": "Resolved today",
  "dashboard.mine.participating": "Participating",
  "dashboard.updates.title": "Latest updates",
  "dashboard.updates.search": "Search updates",
  "dashboard.updates.empty": "No matching updates",
  "dashboard.updates.action.statusChanged": "{actor} changed the status to “{target}”",
  "dashboard.updates.action.assigned": "{actor} assigned it to {target}",
  "dashboard.updates.action.unassigned": "{actor} removed the assignee",
  "dashboard.updates.action.routed": "{actor} routed it to {target}",
  "dashboard.updates.action.replied": "{actor} replied to the customer"
}
